import '../../modules/mode-components';

import * as angular from 'angular';

import { ClientDataService } from '~/services/client-data-service';

import SQLSettingsModalTemplate from './modal-sql-settings-template.html';

export default class SqlSettingsModalController implements angular.IController {
  //bindings
  preferences: any;
  onSubmit: () => void;
  onCancel: () => void;

  // local state
  sqlSettingsForm: any;

  static $inject = ['ClientDataService'];

  constructor(private clientDataService: ClientDataService) {}

  $onInit() {
    this.sqlSettingsForm = this.generateSqlSettingsObject();
  }

  save(sqlSettingsForm) {
    // we are currently only supporting this suggestion_mode
    sqlSettingsForm.show_autocomplete_suggestion_mode = 'char_count';
    // model layer will strip out empty arrays, so we save none to make the persistance work
    if (sqlSettingsForm.make_suggestions_for.length === 0) {
      sqlSettingsForm.make_suggestions_for = ['none'];
    }
    this.clientDataService.updateAccountPreference({
      sql_editor_preferences: {
        ...sqlSettingsForm,
      },
    });

    this.onSubmit();
  }

  cancel() {
    this.onCancel();
  }

  handleSuggestionsForChange($event, suggestionValue) {
    $event.preventDefault();
    $event.stopPropagation();
    if (this.sqlSettingsForm.make_suggestions_for.includes(suggestionValue)) {
      this.sqlSettingsForm.make_suggestions_for = this.sqlSettingsForm.make_suggestions_for.filter(
        (value) => value !== suggestionValue
      );
    } else {
      this.sqlSettingsForm.make_suggestions_for.push(suggestionValue);
    }
  }

  private get preferenceForm() {
    return this.preferences._resource._forms.edit._inputs.preference.sql_editor_preferences;
  }

  private generateSqlSettingsObject() {
    const extractedSettingsObject = {};
    Object.keys(this.preferenceForm).map((settingsKeyName) => {
      extractedSettingsObject[settingsKeyName] =
        this.preferences.sql_editor_preferences[settingsKeyName] ?? this.preferenceForm[settingsKeyName].value;
    });
    //because you cant save an empty array, we save none, so we need to clean that from the array when the api returns it
    const index = extractedSettingsObject['make_suggestions_for'].indexOf('none');
    if (index > -1) {
      extractedSettingsObject['make_suggestions_for'].splice(index, 1);
    }

    return extractedSettingsObject;
  }
}

const SQLSettingsModalComponent: angular.IComponentOptions = {
  bindings: {
    preferences: '<',
    onSubmit: '&',
    onCancel: '&',
  },
  controller: SqlSettingsModalController,
  controllerAs: 'ctrl',
  template: SQLSettingsModalTemplate,
};

// IMPORTANT - Don't forget to also update the /frontend/src/core-app file with an import of this component.
angular.module('mode.components').component('sqlSettings', SQLSettingsModalComponent);
